import { ModelInstance, BaseModel, ToFrontHook, ToBackHook } from './util';
import { File } from './file';

@ModelInstance({
  mappingFields: {
    id: 'id',
    original_photo: 'originalPhoto',
    list_photo: 'listPhoto',
    detail_photo: 'detailPhoto',
    game: 'game',
    tournament: 'tournament',
    game_id: 'gameId',
    tournament_id: 'tournament_id',
    video_url: 'videoUrl',
    video_preview: 'videoPreview',
    is_live: 'isLive',
  },
  relation: {
    originalPhoto: File,
    listPhoto: File,
    detailPhoto: File,
    videoPreview: File
  }
})
export class MediaItem extends BaseModel {
  id: number;
  originalPhoto: File;
  listPhoto: File;
  detailPhoto: File;
  gameId: number;
  tournamentId: number;
  videoUrl: string;
  videoPreview: File;
  isLive: boolean;

  get isVideo(): boolean {
    return Boolean(this.videoUrl);
  }

  @ToFrontHook
  static toFront(data: any): any {}

  @ToBackHook
  static toBack(data: any): any {}
}
